import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78b697aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "backdoor-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "三勘院绑定数据", -1))

import { onMounted, ref } from 'vue'
import { PAGE_SIZES } from '@/common'
import { devicePage } from '@/api'
import OperationButtonList from '@/components/operation-button-list'
import { useAuthStore } from '@/stores/auth'
import ConfDrawer from './components/conf-drawer.vue'
import { queryDeviceConfInfoPage } from '@/api'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const authStore = useAuthStore()

authStore.queryAuth()

const buttonList = ref([
  {
    type: 'edit',
    text: '编辑',
  },
])

const columns = [
  {
    prop: 'deviceName',
    label: '设备名称',
  },
  {
    prop: 'deviceSn',
    label: 'SN',
  },
  {
    prop: 'deviceSn',
    label: '配置类型-key-秘钥-第三方设备sn',
    formatter: ({ confList }: any) => {
      return (
        (confList || [])
          .map(({ configCode, deviceKey, deviceSecret, opDevicedSn }: any) => {
            return `${configCode}-${deviceKey}-${deviceSecret}-${opDevicedSn}`
          })
          .join('、') || '-'
      )
    },
  },
]

const tableData: any = ref([])

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const tableLoading = ref(false)

const fetchList = async () => {
  tableLoading.value = true

  const res: any = await queryDeviceConfInfoPage({
    ...pageParams.value,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === 0) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}
onMounted(() => {
  fetchList()
})

const formConf = ref({
  visible: false,
  data: {},
})

const handleConf = (data: any) => {
  formConf.value = {
    visible: true,
    data,
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        stripe: "",
        class: "ws_mt20 ws_common_table"
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, { description: "暂无数据" })
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (item) => {
            return _createVNode(_component_el_table_column, _mergeProps({
              key: item.prop
            }, {
          ...item,
        }, { "show-overflow-tooltip": "" }), null, 16)
          }), 64)),
          _createVNode(_component_el_table_column, {
            prop: "operation",
            width: "280",
            label: "操作"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_unref(OperationButtonList), {
                buttonList: buttonList.value,
                scope: scope.row,
                onOnEdit: handleConf
              }, null, 8, ["buttonList", "scope"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ]),
      _createVNode(_component_el_pagination, {
        class: "ws_mt50",
        "current-page": pageParams.value.curPage,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageParams.value.curPage) = $event)),
        "page-size": pageParams.value.pageSize,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.pageSize) = $event)),
        "page-sizes": _unref(PAGE_SIZES),
        layout: "->, total, sizes, prev, pager, next, jumper ",
        total: total.value,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
    ]),
    _createVNode(ConfDrawer, {
      visible: formConf.value.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((formConf.value.visible) = $event)),
      data: formConf.value.data,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})